module.exports = __webpack_public_path__ + "static/media/reportBadgeLevel4Locked.762845d3.png";